// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { circleFilled16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-circle-filled': IconCircleFilled;
    }
}

/**
 * The icon component for the 'circleFilled' icon
 */
export class IconCircleFilled extends IconSvg {
    public constructor() {
        super(circleFilled16X16);
    }
}

registerIconSvg('icon-circle-filled', IconCircleFilled);
export const iconCircleFilledTag = 'nimble-icon-circle-filled';
